import styled from '@emotion/styled';
import { RacemapColors } from '@racemap/utilities/consts/common';
import { Badge, Button } from 'antd';
import React from 'react';
import { useStore } from '../../../store/reducers';
import { DragLayer, Preview } from '../../BasicComponents/DragLayer';
import { IconArrowDoubleLeft } from '../../Icon';
import { FilterTree } from '../Filter/FilterTree';
import { Column } from './Column';
import { TopBar } from './TopBar';

interface Props {
  onLeftClose: () => void;
}

export const FilterAndTagsColumn = React.memo(function FilterAndTagsColumn({ onLeftClose }: Props) {
  const filterSet = useStore((s) => s.trackers.filterSet);
  const isSomethingSelected = filterSet.size > 0;
  const { resetFilterSelection } = useStore((s) => s.trackers.actions);

  return (
    <Column
      topBarContent={
        <Bar>
          <BarTitle>
            Filter:
            <Badge
              count={filterSet.size}
              size={'small'}
              offset={[0, 5]}
              color={RacemapColors.PaleBlue}
            >
              <Button size="small" onClick={resetFilterSelection} disabled={!isSomethingSelected}>
                Reset
              </Button>
            </Badge>
          </BarTitle>
          <IconArrowDoubleLeft onClick={onLeftClose} />
        </Bar>
      }
    >
      <Content>
        <DragLayer
          targetItemType={'filter-tree'}
          renderPreview={(item: any) => <Preview>{item.count} Trackers</Preview>}
        />
        <FilterTree />
      </Content>
    </Column>
  );
});

const Bar = styled(TopBar)`
  justify-content: space-between;
`;
const BarTitle = styled.div`
  color: ${RacemapColors.DarkGray};
  display: flex;
  column-gap: 5px;
`;
const Content = styled.div`
  padding: 5px;
  height: 100%;
  overflow: auto;
`;
